import { bodyBgGradientAngle } from './BodyBgStore';

import { bodyBgGradientAngleDefault } from './BodyBgStoreDefaults';

export const resetBodyBgGradientAngle = () => bodyBgGradientAngle.set(bodyBgGradientAngleDefault);
